import Logo from '../img/Logo-Colegio.png';

const HeaderActaAdultos = () => {
    return (
      <header className="acta-header">
        <img
          src={Logo}
          alt="Logo Gobe Campus"
          className="escudo"
        />
        <div className="header-content">
          <h2>GOBE CAMPUS</h2>
          <p>Educación para adultos</p>
        </div>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Coat_of_arms_of_Colombia.svg/1200px-Coat_of_arms_of_Colombia.svg.png"
          alt="Escudo de Colombia"
          className="escudo"
        />
      </header>
    );
  };
  
  export default HeaderActaAdultos;
  